import React from 'react';
import { cx } from './cx';
import Icon from './Icon';

export const panelVariants = ['default', 'dark', 'light'] as const;
export type PanelVariant = (typeof panelVariants)[number];

interface PanelProps {
  id?: string;
  title?: string;
  titleId?: string;
  children: React.ReactNode;
  variant?: PanelVariant;
  className?: string;
  onClose?: () => void;
}

function variantClass(variant: PanelVariant): string {
  switch (variant) {
    case 'default':
      return '';
    case 'dark':
      return 'osrs-panel--dark';
    case 'light':
      return 'osrs-panel--light';
    default: {
      const neverVariant: never = variant;
      return neverVariant;
    }
  }
}

const Panel: React.FC<PanelProps> = ({
  id,
  title,
  titleId,
  children,
  variant = 'default',
  className,
  onClose,
}) => {
  return (
    <div id={id} className={cx('osrs-panel', variantClass(variant), className)}>
      {title && (
        <div className="osrs-panel__title" id={titleId}>
          <span>{title}</span>
          {onClose && (
            <button type="button" className="osrs-btn osrs-panel__close" onClick={onClose} aria-label="Close">
              <Icon name="close" />
            </button>
          )}
        </div>
      )}
      <div>{children}</div>
    </div>
  );
};

export default Panel;
